module.exports = __webpack_public_path__ + "media/svg/sl-04b633de.svg";